/**
 * Ключ строки таблицы — один резолвер на все представления.
 *
 * Ключ обязан совпадать везде: под ним выбор лежит в `RepositoryController` и
 * персистится, по нему таблица ставит галочки, по нему же bulkActions разрешают
 * выбранные строки. Раньше логика была продублирована в обычной обёртке, в
 * групповой и inline у вызова массового действия — и в третьем месте индекс
 * подставлялся нулём.
 */

/**
 * Создаёт резолвер ключа строки.
 *
 * @param getRowId Кастомный ключ таблицы (проп `getRowId`). Если не передан —
 *   бизнесовый `row.id`, а при его отсутствии позиция строки.
 * @returns Функция ключа. Индекс необязателен: он нужен только строкам без `id`
 *   (fallback на позицию). Там, где позиция не определена — например при
 *   разрешении выбранных строк, которые собраны из разных групп, — индекс можно
 *   не передавать: кастомные резолверы строят ключ по данным строки.
 */
export function createRowKeyResolver<T extends Record<string, unknown>>(
  getRowId?: (row: T, index: number) => string
): (row: T, index?: number) => string {
  return (row, index) => {
    if (getRowId) return getRowId(row, index ?? 0);
    const id = row.id;
    if (id != null) return String(id);
    return index == null ? '' : String(index);
  };
}
